<template lang="pug">


  .ButtonPodcast( ref="btnPodcast" ,@click="clickedButton" , :class="{ isPlaying: isPlaying || isFixed || !isDesktop, isFixed : isFixed , isAbsolute : !isFixed , isNotDesktop : !isDesktop}" )
    span.TourCover_podcastBtnLabel( v-if="!this.isPlaying && !this.isFixed && this.isDesktop" ) {{ $tc('tour.tour_podcast') }}
    span.TourCover_podcastBtnIcon
      RadialProgress(
        :class="{ RadialProgressMobile: !isDesktop }"
        v-if="this.isPlaying"
        :progress="progress"
        :diameter="this.diameter"
        :placeholderStrokeWidth="1"
        :progressStrokeWidth="this.progressStrokeWidth"
      )
      SvgInline( v-if="!isPlaying" src="play" , ref="iconPodcastPlayer")
      SvgInline( v-if="isPlaying" src="pause" , ref="iconPodcastPlayer")
  
</template>

<script>
import scrollUpdate from '@/mixins/scrollUpdate'
import SvgInline from '@/components/SvgInline'
import RadialProgress from '@/components/RadialProgress'
import {Howl, Howler} from 'howler'
import raf from 'raf'
import { mapGetters , mapActions } from "vuex"

export default {
  props: ['url'],
  mixins: [scrollUpdate],
  components: { SvgInline , RadialProgress },
  data () {
    return {
      isPlaying: false,
      currentTime: 0,
      totalTime: 0,
      scrollValue: 0,
      btnVerticalAlign: 0,
      isDesktop: true,
      isFixed: false,
      diameter: 0,
      progressStrokeWidth: 0
    }
  },
  computed: {
    ...mapGetters(['audioPlayerStateParagraph']),
    progress () {
      return this.currentTime / this.totalTime || 0
    }
  },
  watch: {
    isPlaying () {
      if (this.isPlaying) {
        this.play()
      } else {
        this.stop()
      }
    },
    audioPlayerStateParagraph() {
      if (this.audioPlayerStateParagraph) {
        this.isPlaying = false
      }
    }
  },
  mounted () {
    this.createSound();
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  beforeDestroy () {
    this.stop();
    window.removeEventListener('resize', this.onResize)
  },
	methods: {
    ...mapActions(["updateAudioPlayerState"]),
    onResize () {
      if(window.innerWidth > 768){
        if(document.body.querySelector('.isAbsolute')){
          if(window.innerWidth > 1024){
            document.body.querySelector('.isAbsolute').style.top = (window.innerHeight - 100)+"px"
          }else{
            document.body.querySelector('.isAbsolute').style.top = (window.innerHeight - 90)+"px"
          }
        } 
        this.isDesktop = true
        this.diameter = 50
        this.progressStrokeWidth = 4
      }else{
        this.diameter = 40
        this.progressStrokeWidth = 3
        this.isDesktop = false
      }
    },
    onScrollUpdate (){
      this.scroll = document.body.querySelector('.MainContainer').scrollTop
      this.btnVerticalAlign = (window.innerHeight/2)-100;

      if(this.scroll > this.btnVerticalAlign){
        this.isFixed = true
      }else{
        this.isFixed = false
      }
    },
		clickedButton: function() {
      this.isPlaying = !this.isPlaying
    },
    createSound () {
      this._sound = new Howl({
        src: [this.url],
        onend: () => {
          this.isPlaying = !this.isPlaying
        },
        onload: () => {
          this.totalTime = this._sound.duration()
        }
      })
    },
    play () {
      this._sound.play()
      this.stopListeningForProgress()
      this.startListeningForProgress()
      this.updateAudioPlayerState( { 
        name : 'podcast',
        data : true 
      })
    },
    stop () {
      this._sound.stop()
      this.stopListeningForProgress()
      this.updateAudioPlayerState( { 
        name : 'podcast',
        data : false 
      })
    },
    startListeningForProgress () {
      this._progressRAF = raf(this.onProgress)
    },
    stopListeningForProgress () {
      raf.cancel(this._progressRAF)
    },
    onProgress () {

      this.currentTime = this._sound.seek()
      this._progressRAF = raf(this.onProgress)

    }
	}
}

</script>

<style lang="stylus" scoped>

  .RadialProgress

    position absolute
    top 7px
    right 7px

  .displayText
    

  .ButtonPodcast

    position absolute
    z-index: 105;
    top 500px
    right 50px
    padding 4px 25px
    height 40px
    text-transform uppercase
    color $beige
    width fit-content
    display block
    line-height 40px
    text-decoration none
    border 1px solid $beige
    border-radius 50px
    cursor pointer
    white-space: nowrap;
    overflow hidden
    background-color rgba(0, 0, 0, 0.75);
    backface-visibility: hidden;
    transition: border-color 0.3s, color 0.3s, transform 1s, opacity 0.8s ;
    transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);

    &:before

      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 150%;
      height: 100%;
      background: white;
      z-index: -1;
      transform: rotate3d(0, 0, 1, -45deg) translate3d(0, 3em, 0);
      transform-origin: 100% 0%;
      transition: transform 0.3s, opacity 0.3s, background-color 0.3s;

    &_black

      border-color $black
      color $beige
      background-color $black
      padding-top 0px
      padding-bottom 0px

      &:before

        background $grey-1

    @media $mq_s_only
      font-size 14px
      white-space: normal;
      padding 10px 25px

    svg
      width 10px
      margin-left 15px

    &-with-background
      background-color rgba(0,0,0,0.5)

    &:hover, &.hover

      border-color transparent
      color $black
      // zoom : 98%;
      transform translateZ(0) perspective(1px)

      &:before

        opacity: 1;
        background-color: $beige;
        transform: rotate3d(0, 0, 1, 0deg);
        transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);

    &:focus

      transform translateZ(0) perspective(1px)
      opacity 0.5

  .isPlaying


    margin-top -7px
    padding 0px
    height 64px
    width 64px
    border-radius 50px
    border 0px


    svg
      width 14px
      margin-left 25px
      margin-top 23px

  .isAbsolute

    position  absolute

  .isFixed

    position  fixed
    top: calc(50% - 25px) !important


  .isNotDesktop


    margin-top 0px
    right 20px
    height 50px
    width 50px
    position  fixed
    top: calc(100% - 70px) !important

    svg
      width 12px
      margin-left 19px
      margin-top 17px

  .RadialProgressMobile
    top: 5px;
    right: 5px;

    

</style>
